import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ChatRoutingModule } from './chat-routing.module';
import { ChatComponent } from './chat/chat.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@huge-monorepo/shared/modules';
import { ToolsModule } from 'libs/portal/src/modules/tools/tools.module';
import { MatColComponent } from '../../../tools/mat-col/mat-col.component';
import { MatRowComponent } from '../../../tools/mat-row/mat-row.component';

@NgModule({
  declarations: [ChatComponent],
  imports: [CommonModule, ChatRoutingModule, FormsModule, ReactiveFormsModule, MaterialModule, ToolsModule, MatColComponent, MatRowComponent],
})
export class ChatModule {}
